import { render, staticRenderFns } from "./TestResultMain.vue?vue&type=template&id=ff95e21a&scoped=true&"
import script from "./TestResultMain.vue?vue&type=script&lang=js&"
export * from "./TestResultMain.vue?vue&type=script&lang=js&"
import style0 from "./TestResultMain.vue?vue&type=style&index=0&id=ff95e21a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff95e21a",
  null
  
)

export default component.exports